/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {oAuthResolveFlow} from '../api'

export const useMutationOAuthResolveFlow = createReactQueryMutationHook('oAuthResolveFlow', oAuthResolveFlow)
